import { Link, useLocation } from "react-router-dom"

const NavLink = ({href, title, onClick}) => {
  const location = useLocation();

  const scrollToTop = ()=>{
    window.scrollTo({
      top: 0,
      behavior: 'smooth', 
    });
  };
  const isActive = location.pathname === href;
  return (
    <div>
        <Link 
          to={href}
          className={`block py-2 pl-3 pr-4 text-primary1 font rounded md:p-0 hover:text-tertary2 text-["Montserrat", Arial, Helvetica, sans-serif] ${isActive ? "text-[#8a4878] font-bold" : "text-primary1"}`}
          onClick={() => {
            scrollToTop();
            if (onClick) {
              onClick(); 
            }
          }}
        >
          {title}
        </Link>
    </div>
  )
}

export default NavLink